import React from "react";

export const TableLoader = ({
  rows = 10,
  columns = 5,
  showHeader = true,
}) => {
  return (
    <div className="table-wrapper">
      <table className="courses-table">
        {/* 🔹 Header Skeleton */}
        {showHeader && (
          <thead>
            <tr>
              {Array.from({ length: columns }).map((_, i) => (
                <th key={i}>
                  <div className="skeleton skeleton-header"></div>
                </th>
              ))}
            </tr>
          </thead>
        )}
        {/* 🔹 Body Skeleton */}
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex}>
                  <div
                    className={`skeleton ${
                      !showHeader && rowIndex === 0
                        ? "skeleton-header-row"
                        : "skeleton-cell"
                    }`}
                  ></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* 🔹 Skeleton CSS */}
      <style>
        {`
          .skeleton {
            width: 100%;
            border-radius: 6px;
            background: linear-gradient(
              90deg,
              #edf2f7 25%,
              #e2e8f0 37%,
              #edf2f7 63%
            );
            background-size: 400% 100%;
            animation: skeleton-loading 1.2s ease-in-out infinite;
          }

          /* 🔹 Actual header skeleton */
          .skeleton-header {
            height: 16px;
            margin: auto;
          }

          /* 🔹 First row when header is hidden */
          .skeleton-header-row {
            height: 20px;
          }

          /* 🔹 Normal rows */
          .skeleton-cell {
            height: 14px;
          }

          @keyframes skeleton-loading {
            0% {
              background-position: 100% 0;
            }
            100% {
              background-position: -100% 0;
            }
          }
        `}
      </style>
    </div>
  );
};
